import React, { useState } from 'react';
import { DeleteOutlined, EditOutlined } from '@mui/icons-material';
import axios from 'axios';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Box, } from '@mui/material';
export const InterventionsTable = ({ items, onEdit, onDelete, isEditDisabled }) => {
    const [hoveredRow, setHoveredRow] = useState(null);
    const deleteItem = async (item) => {
        await axios.post('/api/carePlan/deleteIntervention', {
            interventionId: item.id,
        });
        onDelete?.(item.id);
    };
    return (React.createElement(TableContainer, { component: Paper },
        React.createElement(Table, null,
            React.createElement(TableHead, null,
                React.createElement(TableRow, { style: { backgroundColor: '#EEEEEE', color: '#000000DE', fontFamily: 'Barlow', fontWeight: '500' } },
                    React.createElement(TableCell, null, "Intervention"),
                    React.createElement(TableCell, null, "Frequency"),
                    React.createElement(TableCell, null, "Notes"),
                    React.createElement(TableCell, null))),
            React.createElement(TableBody, null, items.map((intervention, index) => (React.createElement(TableRow, { key: index, onMouseEnter: () => setHoveredRow(index), onMouseLeave: () => setHoveredRow(null), sx: {
                    '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    },
                } },
                React.createElement(TableCell, { style: { overflowWrap: 'anywhere' } }, intervention.intervention),
                React.createElement(TableCell, { style: { overflowWrap: 'anywhere' } }, intervention.frequency),
                React.createElement(TableCell, { style: { overflowWrap: 'anywhere', whiteSpace: 'pre-wrap', } }, intervention.interventionDescription),
                React.createElement(TableCell, null,
                    React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
                        React.createElement(Box, { sx: {
                                display: 'flex',
                                gap: 0.5,
                                opacity: hoveredRow === index ? 1 : 0,
                                transition: 'opacity 0.2s',
                            } },
                            React.createElement(IconButton, { style: { height: '20px', width: '20px', color: '#0000008A' }, size: "small", disabled: isEditDisabled, onClick: (e) => {
                                    e.stopPropagation();
                                    onEdit?.(intervention.id);
                                } },
                                React.createElement(EditOutlined, { style: { height: '20px', width: '20px', color: '#0000008A' }, fontSize: "small" })),
                            React.createElement(IconButton, { size: "small", disabled: isEditDisabled, style: { height: '20px', width: '20px', color: '#D32F2F' }, onClick: (e) => {
                                    e.stopPropagation();
                                    deleteItem(intervention);
                                } },
                                React.createElement(DeleteOutlined, { style: { height: '20px', width: '20px', color: '#D32F2F' }, fontSize: "small" }))))))))))));
};
